import {
  GENERIC_SEARCH_FAILURE,
  GENERIC_SEARCH_REQUEST,
  GENERIC_SEARCH_SUCCESS,
} from '../../../Constants/actionTypes';

import { generi_search } from '../../../Constants/apiService'


// Action to start search
export const genericSearchRequest = () => ({
  type: GENERIC_SEARCH_REQUEST,
});

// Action when search is successful
export const genericSearchSuccess = (results) => ({
  type: GENERIC_SEARCH_SUCCESS,
  payload: results,
});

// Action when search fails
export const genericSearchFailure = (error) => ({
  type: GENERIC_SEARCH_FAILURE,
  payload: error,
});


export const generiSearch = (query) => {
  console.log(query)
  return async (dispatch, getState) => {
    dispatch(genericSearchRequest());

    const state = getState();
    const accessToken = state.auth.accessToken;

    try {

      const data = await generi_search(accessToken, query);
      console.log(data)
      dispatch(genericSearchSuccess(data));

    } catch (error) {
      let errorMessage;
      if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
        errorMessage = 'Server is currently down. Please try again later.';
      } else {
        errorMessage = error.message;
      }
      dispatch(genericSearchFailure(errorMessage));
    }


  };
};